import { render } from "./WalletDetailModal.vue?vue&type=template&id=0be248c0&scoped=true"
import script from "./WalletDetailModal.vue?vue&type=script&lang=js"
export * from "./WalletDetailModal.vue?vue&type=script&lang=js"

import "./WalletDetailModal.vue?vue&type=style&index=0&id=0be248c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be248c0"]])

export default __exports__